import axios from 'axios';
import { CHANGE_PASSWORD } from '../../constants';

export const changePassword = (data, toastMessage, onError) => (dispatch) => {
  dispatch(addChangePassword());
  axios
    .post(`admin/changePassword`, data)
    .then((res) => {
      dispatch(setChangePassword(res));
      toastMessage(res.data);
    })
    .catch((err) => {
      dispatch(errorChangePassword(err.response));
      onError(err.response);
    });
};

export const addChangePassword = () => ({
  type: CHANGE_PASSWORD.LOAD
});

export const setChangePassword = (data) => ({
  type: CHANGE_PASSWORD.SUCCESS,
  payload: data.data
});

export const errorChangePassword = (error) => ({
  type: CHANGE_PASSWORD.FAIL,
  payload: error
});
